module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs/wbs.component.css
// module id = ./src/app/wbs/wbs.component.css
// module chunks = main